import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { IsTokenValidForRoutes, IsTokenValid } from "../utils/middleware";
const ProtectedRoute = () => {
  const isAuth = IsTokenValid();
  const location = useLocation();
  if (!isAuth) {
    const redirectPath = `${location.pathname}${location.search}`;
    if (redirectPath && redirectPath !== "/" && redirectPath !== "/login") {
      localStorage.setItem("redirectAfterLogin", redirectPath);
    }
    return <Navigate to="/login" replace />;
  } else {
    const isAuthenticated = IsTokenValidForRoutes();
    return isAuthenticated ? <Outlet /> : <Navigate to="/404" />;
  }
};

export default ProtectedRoute;
